// extracted by mini-css-extract-plugin
module.exports = {"root":"loader-with-overlay_root__2ftB1"};